<template>
    <div class="card" style="min-height: 200px">
        <div class="table-responsive">
            <table class="table">
                <thead>
                <tr>
                    <th>Date</th>
                    <th>Invoice Number</th>
                    <th>Party Name</th>
                    <th class="text-right">Invoice Amount</th>
                    <th class="text-right">VAT Amount</th>
                    <th class="text-right">Total Value</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in salesList" :key="i">
                    <td>{{ item.date }}</td>
                    <td>{{ item.bill_number }}</td>
                    <td>{{ item.party_name }}</td>
                    <td class="text-right">{{ commaFormat(getTaxableValue(item)) }}</td>
                    <td class="text-right">{{ commaFormat(item.vat_amount) }}</td>
                    <td class="text-right">{{ commaFormat(item.bill_amount) }}</td>
                    <td>
                        <div class="dropdown">
                            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown">
                                <i class="fas fa-print"></i>
                            </button>
                            <ul class="dropdown-menu">
                                <li>
                                    <a class="dropdown-item" href="#" @click.prevent="goToMushakPrint(item.id)">
                                        <i class="fas fa-print me-2"></i> Print Mushak 6.3
                                    </a>
                                </li>
                                <li>
                                    <a class="dropdown-item" href="#" @click.prevent="goToMushakPrintEn(item.id)">
                                        <i class="fas fa-print me-2"></i> Print Mushak 6.3 (EN)
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <p v-if="!salesList.length" class="text-center mt-5">No data</p>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import figureFormatter from '@/services/utils/figureFormatter'
import handlePurchase from '@/services/modules/purchase'
import handleCompany from '@/services/modules/company'
import printMushak63 from '@/services/utils/pdf/mushakPdf'
import printMushak63En from '@/services/utils/pdf/mushakPdfEn'

defineProps({
    salesList: {
        type: Array,
        default: () => []
    }
})

const $route = useRoute()
const $store = useStore()

const { commaFormat } = figureFormatter()
const { fetchSalesBill } = handlePurchase()
const { fetchCompanyInfo } = handleCompany()
const { exportToPdfMushak } = printMushak63()
const { exportToPdfMushakEn } = printMushak63En()

const companyInfo = ref({})
const user = ref({})

function toNumber(value) {
    const parsed = parseFloat(value)
    if (isNaN(parsed)) return 0
    return parsed
}

function getTaxableValue(item) {
    return toNumber(item.bill_amount) - toNumber(item.vat_amount)
}

function goToMushakPrint(id) {
    const companyQuery = `?company_id=${$route.params.companyId}`
    fetchSalesBill(id, companyQuery).then((res) => {
        if (!res) return
        exportToPdfMushak(companyInfo.value, res.data, user.value)
    })
}

function goToMushakPrintEn(id) {
    const companyQuery = `?company_id=${$route.params.companyId}`
    fetchSalesBill(id, companyQuery).then((res) => {
        if (!res) return
        exportToPdfMushakEn(companyInfo.value, res.data, user.value)
    })
}

onMounted(() => {
    fetchCompanyInfo($route.params.companyId).then((res) => {
        companyInfo.value = res.data
    })
    user.value = $store.state.user.user
})
</script>

<style scoped>
.table-responsive {
    overflow: visible;
}
.dropdown-menu.show {
    z-index: 1055;
}
</style>
